import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { Link } from "gatsby"
import kebabCase from "lodash.kebabcase"
import leftarrowBlack from "../images/icons/leftarrowBlack.svg"
import rightarrowBlack from "../images/icons/rightarrowBlack.svg"
import Twitter from "../images/new_website/blogs/twitter.svg"
import Facebook from "../images/new_website/blogs/facebook.svg"
import Linkedin from "../images/new_website/blogs/linkedin.svg"
import Mail from "../images/new_website/blogs/mail.svg"
import Seo from "../components/seo"
import * as allImages from "../utils/images"
import Enquiry from "../components/enqiry"
import {
  Alert,
  Box,
  Container,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import chatIcon from "../images/icons/chatIcon.svg"
import ContactDialog from "../components/contactDialog"
import { API_URL } from "../utils/config"

export default function BlogPost({ data, pageContext }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const [snackbarOpen, setSnackbarOpen] = React.useState(false)
  const [snackbarMessage, setSnackbarMessage] = React.useState("")
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success")
  const { previous, next } = pageContext
  const post = data.markdownRemark
  console.log("post", post, "pageContext", pageContext)
  const blogpostdata = data.allMarkdownRemark
  let psuedoUrl
  blogpostdata.edges.map(item => {
    if (item.node.frontmatter.title === post.frontmatter.title) {
      psuedoUrl = item.node.fields.slug
    }
  })
  const Url1 = psuedoUrl.replace("/", "")
  const Url = Url1.replace("/", "")
  const showBlueNavbar = true
  const baseUrl = typeof window !== "undefined" ? window.location.origin : ""
  const fullUrl = `${baseUrl}${psuedoUrl}`

  const initialValue = {
    Email: "",
    Assist: "This email is regarding the blog post subscription",
  }

  React.useEffect(() => {
    const sidebarLinks = document.querySelectorAll(".sidebar-links-section li")
    const form = document.getElementById("emailForm")

    const removeActiveClass = () => {
      sidebarLinks.forEach(link => link.classList.remove("active-link"))
    }

    const handleClick = event => {
      event.preventDefault()
      const target = event.currentTarget
      removeActiveClass()
      target.classList.add("active-link")
      const targetId = target.getAttribute("data-target")
      const targetElement = document.getElementById(targetId || "")

      // Smooth scroll to the target section
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
    }

    const handleSubscribe = async event => {
      event.preventDefault()
      const email = event.target.email.value
      initialValue.Email = email
      const formData = new FormData()
      for (const key in initialValue) {
        formData.append(key, initialValue[key])
      }
      await fetch(`${API_URL}/contact`, {
        method: "POST",
        body: formData,
      })
        .then(response => response.json())
        .then(result => {
          if (result.success || result.status == 200) {
            event.target.reset()
            setSnackbarMessage("You have successfully subscribed!")
            setSnackbarSeverity("success")
            setSnackbarOpen(true)
          } else {
            setSnackbarMessage("Failed to subscribe. Please try again.")
            setSnackbarSeverity("error")
            setSnackbarOpen(true)
          }
        })
        .catch(e => {
          setSnackbarMessage(e.message || "Something went wrong!")
          setSnackbarSeverity("error")
          setSnackbarOpen(true)
        })
    }

    sidebarLinks.forEach(li => {
      li.addEventListener("click", handleClick)
    })

    if (form) {
      form.addEventListener("submit", handleSubscribe)
    }

    // Clean up event listeners on component unmount
    return () => {
      sidebarLinks.forEach(li => {
        li.removeEventListener("click", handleClick)
      })
      if (form) {
        form.removeEventListener("submit", handleSubscribe)
      }
    }
  }, [post])

  // useEffect to bind click handlers
  React.useEffect(() => {
    const handleShareClick = event => {
      const target = event.target
      const shareType = target.getAttribute("data-share")

      switch (shareType) {
        case "email":
          window.open(
            `mailto:?subject=${post?.frontmatter?.title}&body=${fullUrl}`,
            "_blank"
          )
          break
        case "linkedin":
          window.open(
            `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
              fullUrl
            )}`,
            "_blank"
          )
          break
        case "instagram":
          window.open("https://www.instagram.com/", "_blank") // Instagram doesn’t support direct share URLs
          break
        case "facebook":
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              fullUrl
            )}`,
            "_blank"
          )
          break
        default:
          break
      }
    }

    // Attach event listener to each share icon
    const shareIcons = document.querySelectorAll(
      ".share-post-section .social-icon"
    )
    shareIcons.forEach(icon => icon.addEventListener("click", handleShareClick))

    // Clean up event listeners on component unmount
    return () => {
      shareIcons.forEach(icon =>
        icon.removeEventListener("click", handleShareClick)
      )
    }
  }, [fullUrl, post.frontmatter.title])

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      if (scrollTop + windowHeight >= documentHeight * 0.2) {
        post.frontmatter.isPromoModal && openContactDialog()
        window.removeEventListener("scroll", handleScroll)
      }
    }
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [post.frontmatter.isPromoModal])

  //contact dialog
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false)
  const [showErrorMessage, setShowErrorMessage] = React.useState(false)
  const openContactDialog = () => {
    setIsDialogOpen(true)
    setShowSuccessMessage(false)
    setShowErrorMessage(false)
  }
  const closeContactDialog = () => setIsDialogOpen(false)
  const handleSuccessMsg = () => {
    setShowSuccessMessage(true)
  }
  const handleErrorMsg = () => {
    setShowErrorMessage(true)
  }

  return (
    <Layout showBlueNavbar={true}>
      {post?.frontmatter?.title ? (
        <Seo
          title={
            post?.frontmatter?.metaTitle
              ? post.frontmatter.metaTitle
              : post.frontmatter.title
          }
          url={Url}
          description={post.frontmatter.description}
          keywords={post.frontmatter.keywords}
          previewImage={post.frontmatter.image}
        />
      ) : (
        ""
      )}
      <ContactDialog
        open={isDialogOpen}
        handleClose={closeContactDialog}
        onSubmitSuccess={handleSuccessMsg}
        onSubmitError={handleErrorMsg}
        showSuccessMessage={showSuccessMessage}
        showErrorMessage={showErrorMessage}
        isPromoDialog={false}
        isPromoFormDialog={true}
      ></ContactDialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%", alignItems: "center" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div
        className={
          post?.frontmatter?.layout === "full"
            ? "knowledge-article-wrapper"
            : "blogs-wrapper"
        }
      >
        <div
          className={
            post?.frontmatter?.layout === "full"
              ? ""
              : "container-md desktopBlog"
          }
        >
          <div
            className={
              post?.frontmatter?.layout === "full"
                ? ""
                : "row"
            }
          >
            <div
              className={
                post?.frontmatter?.layout === "full"
                  ? ""
                  : "col-12"
              }
            >
              <div
                className={
                  post?.frontmatter?.layout === "full"
                    ? ""
                    : "markdown-blog-detail"
                }
              >
                {post?.frontmatter?.layout !== "full" && (
                    <div className="blog-nav-wrapper">
                      <div className="blog-nav-link text-right">
                        <span>
                          {previous && (
                            <Link
                              style={{ color: "#fff" }}
                              paintDrip
                              duration={1}
                              to={previous.fields.slug}
                              rel="prev"
                            >
                              <img
                                src={leftarrowBlack}
                                className="prevArrow"
                                alt="leftarrow"
                              />
                              Previous
                            </Link>
                          )}
                        </span>

                        <span className="ml-4">
                          {next && (
                            <Link
                              style={{ color: "#fff" }}
                              paintDrip
                              duration={1}
                              to={next.fields.slug}
                              rel="next"
                            >
                              Next{" "}
                              <img
                                src={rightarrowBlack}
                                className="nextArrow"
                                alt="rightarrow"
                              />
                            </Link>
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                <div
                  className="pt-4"
                  data-aos="fade-up"
                  data-aos-easing="linear"
                  data-aos-duration="500"
                >
                  <div
                    className="blog-main-content"
                    dangerouslySetInnerHTML={{ __html: post?.html }}
                  />

                  {post?.frontmatter?.layout !== "full" && (
                      <div className="blog-extra-info mt-3">
                        <ul>
                          <li>
                            <span>By {post?.frontmatter?.author}</span>
                          </li>
                          <li>
                            <span>
                              {post?.frontmatter?.date || "No date available"}
                            </span>
                          </li>
                          <li>
                            <span>
                              Categories: {post?.frontmatter?.categories}
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        className="discussYourProject"
        style={{
          borderTop: isMobile ? "1px solid rgb(181 181 181 / 50%)" : "unset",
        }}
      >
        <Container maxWidth="lg">
          <Stack
            sx={{
              position: "relative",
              zIndex: 1,
              pt: isMobile ? 0 : 5,
              pb: 0,
            }}
            direction={isMobile ? "column" : "row"}
            alignItems="center"
          >
            <Stack
              alignItems="center"
              gap={6}
              sx={{ width: isMobile ? "100%" : "50%" }}
            >
              <Stack alignItems="center" textAlign="center" gap={2}>
                {isMobile ? (
                  <></>
                ) : (
                  <img
                    src={chatIcon}
                    alt="Chat"
                    style={{ width: "auto !important" }}
                  />
                )}
                <Typography
                  variant="body1"
                  fontSize={isMobile ? 32 : 16}
                  fontWeight={isMobile ? 700 : 600}
                  color={isMobile ? "#fff" : "#C8DCFA"}
                  textAlign="center"
                >
                  Let's discuss your project
                </Typography>
                {isMobile ? (
                  <></>
                ) : (
                  <Typography
                    variant="h4"
                    color="#fff"
                    fontSize="20px"
                    fontWeight={700}
                    lineHeight="28px"
                    padding="0 30px"
                  >
                    Looking to scale your SaaS effortlessly? <br />
                    Share your project details, and we'll provide tailored
                    solutions to support the growth and security of your SaaS
                    business.
                  </Typography>
                )}
              </Stack>
            </Stack>
            <Box
              sx={{
                width: isMobile ? "100%" : "50%",
                marginTop: isMobile ? "20px" : "0px",
              }}
            >
              <Enquiry />
            </Box>
          </Stack>
        </Container>
      </section>
    </Layout>
  )
}
export const query = graphql`
  query ($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        metaTitle
        date(formatString: "DD MMMM, YYYY")
        categories
        commentCount
        slug
        author
        description
        keywords
        isPromoModal
        layout
        image
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: ASC }) {
      totalCount
      edges {
        node {
          frontmatter {
            title
            date
            commentCount
            author
            keywords
          }
          fields {
            slug
          }
        }
        next {
          frontmatter {
            title
          }
          fields {
            slug
          }
        }
        previous {
          frontmatter {
            title
          }
          fields {
            slug
          }
        }
      }
    }
  }
`
